/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'LIST_UNREADS',
]);



// WEBPACK FOOTER //
// ./src/constants/UnreadConstants.js